
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Apirl 6, 2018
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "ownformsubmissions",
	init: init,
	uninit: uninit,
	_formId: null,
	_group: null,
	_start: null,
	_end: null,
	_page: null,
	_people: {},
	_submissions: [],
	_formList: null,
	_action: null,

	triggers: triggers,
	listeners: listeners,
	recalculate: recalculate,
	clear: clear,

	refresh: refresh
});

function init() {
	this._formId = null,
	this._group = null,
	this._start = null,
	this._end = null,
	this._page = 0;
	this._formList = null;
	this.push({
		hasMore: false,
		form: null,
		group: null,
		submissions: []
	});
}

function uninit() {
	this._formId = null,
	this._group = null,
	this._start = null,
	this._end = null,
	this._page = 0;
	this._formList = null;
}

function triggers() {
	return {
		"search": load,
		"loadMore": loadMore,
		"clear": clear,
		"close": hideForm,
	};
}

function listeners() {
	return {
		"people:updated": Model.makeRecalculator("people"),
		"connectivity:online": refresh,
		"orggroup:updated": handle_orggroup_update,
		"mqtt:$/forms/submission/group/created": handle_created,
		"mqtt:$/forms/submission/group/updated": handle_updated,
		"mqtt:$/forms/submission/group/removed": handle_removed,
		"mqtt:$/forms/submission/group/locked": handle_locked,
		"ownformlist:updated": handle_ownformlist_update,
		"atouchawaysettings:updated": handle_atachawaysettings_update
	};
}

function load(data){
	var form = data.form;
	var start = data.start;
	var end = data.end;
	var page = data.page;

	this._formId = form;
	this._action = data.action;
	this._start = start;
	this._end = end;
	this._page = page || 0;
	this.refresh()
		.then(sayViewing.bind(this));

	this.emit("usermetrics:trigger:track", "view own form submissions", {
		form: form
	});
}

function refresh(){
	var form = this._formId;
	var start = this._start;
	var end = this._end;
	var page = this._page;
	if(!form) return;
	this._page = 0;
	this.emit("save:trigger:start");
	return this.api.forms.submission.group.own.search(form, start, end, page)
		.then(handle_load.bind(this))
		.then(hasMore.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));
}

function hideForm() {
	this.dispatch("form:hidden");
	if(this._action)
		this.emit("activeworkflowaction:trigger:view", {
			action: this._action
		});
	this._action = null;
	this.emit("usermetrics:trigger:track", "close own form submissions");
}

async function recalculate() {
	var submissions = this._submissions;
	var people = this._people;
	var schema;

	var newValue = submissions.reduce(function (result, submission) {
		var editors = submission.editHistory.reduce(function (editorResult, editHistory) {
			var editor = editHistory.id;
			var editorData = people[editor];
			if (editorData) {
				editorData.updated_at = editHistory.updated_at;
				editorResult = editorResult.concat(editorData);
			} else {
				this.emit("people:trigger:add", {
					who: editor,
					lean: true
				});
			}
			return editorResult;
		}.bind(this), []);

		var newSubmission = {};

		newSubmission = xtend(submission, {
			editHistory: editors,
		});

		result = result.concat(newSubmission);

		return result;
	}.bind(this), []);

	if(!this.data && !newValue)
		return;

	if (this._formList && this._formId) {
		schema = this._formList[this._formId].schema;
		let persistStorage;
		try {
			const result = await this.api.persiststorage.getData(this._formId);
			persistStorage = result.persistStorage;
		} catch (error) {
			console.error(error);
		}

		schema.persistStorage = (persistStorage?.length && persistStorage[0]?.data && schema)
			? persistStorage[0].data
			: undefined;
	}
	this.push({
		hasMore: this.data.hasMore,
		form: this._formId,
		schema: schema,
		submissions: newValue
	});
}

function handle_load(list) {
	const formId = this._formId;
	const formsSections = this._formsSections;
	const permission = formsSections[formId];
	if (list.length < 1 && (permission && permission > 1)) {
		this.emit("activeownformsubmission:trigger:creating", {
			id: this._formId,
			mode: "silence"
		});
	}
	this._submissions = list;
	this.push({
		hasMore: this.data.hasMore,
		form: this._formId,
		submissions: list
	});

	return list;
}

function handle_ownformlist_update(list) {
	if (!list) return;
	this._formList = list;

	var formId = this._formId;
	if(!formId) return;

	var stillExists = Object.keys(list).indexOf(formId) !== -1;
	if(!stillExists){
		this.dispatch("form:deleted");
		this.clear();
	}
}

function finishLoad() {
	this.recalculate();
	this.emit("save:trigger:finish");
}

function loadMore(){
	var form = this._formId;
	var start = this._start;
	var end = this._end;

	if(!form) return;

	this._page++;
	var page = this._page;

	this.emit("save:trigger:start");
	this.api.forms.submission.group.own.search(form, start, end, page)
		.then(handle_more.bind(this))
		.then(hasMore.bind(this))
		.catch(console.error.bind(console))
		.then(finishLoad.bind(this));

	this.emit("usermetrics:trigger:track", "load more own form submissions", {
		form: form,
		page: page
	});
}

function handle_more(list) {
	this._submissions = this._submissions.concat(list);
	// this.push({
	// 	submissions: this.data.concat(list)
	// });
	this.recalculate();
	return list;
}

function handle_created(data){
	if(data.schema !== this._formId) return;
	this._submissions = [data].concat(this._submissions);
	this.recalculate();
}

function handle_updated(data){
	var hasUpdated = false;
	var updated = this._submissions.map(function(submission){
		if(submission._id !== data._id) return submission;
		hasUpdated = true;
		var editHistory = data.lastEditor ? submission.editHistory.concat(data.lastEditor) : data.editHistory;
		return xtend(submission, data, {
			editHistory: editHistory
		});
	});
	if(!hasUpdated) return;
	this._submissions = updated;
	this.recalculate();
}

function handle_removed(data){
	var id = data._id;
	var filtered = this._submissions.filter(function(submission){
		return submission._id !== id;
	});
	if(filtered.length === this._submissions.length) return;
	this._submissions = filtered;
	this.recalculate();
}

function handle_locked(data){
	var hasLocked = false;
	var updated = this._submissions.map(function(submission){
		if(submission._id !== data._id) return submission;
		hasLocked = true;
		return xtend(submission, {
			locked: true
		});
	});
	if(!hasLocked) return;
	this._submissions = updated;
	this.recalculate();
}

function handle_orggroup_update(data){
	this._group = data;
}

function sayViewing() {
	this.dispatch("viewing", {
		form: this._formId
	});
}

function clear(){
	this.emit("usermetrics:trigger:track", "close own form submission", {
		form: this._formId
	});

	this._formId = null;
	this.extend({
		form: null,
		submissions: []
	});
	this.dispatch("cleared");
}

function hasMore(list){
	this.extend({
		hasMore: list.length === 32
	});
}

function handle_atachawaysettings_update(data) {
	const formsSections = data.forms_sections;
	this._formsSections = formsSections;
}
